@import "./../../styles/variables";

.smart-country-selector {
  &-banner {
    background-color: #eaeaea;
    padding: 20px;

    @media (max-width: 780px) {
      padding: 20px 16px;
      max-width: 100%;
    }

    &--disabled {
      display: none;
    }

    & > div {
      display: flex;
      justify-content: space-between;
      margin-inline: auto;
      max-width: 1120px;
      width: 100%;

      @media (max-width: 780px) {
        flex-direction: column;
      }
    }

    &-content {
      color: $svs-anthracite-grey;
      display: flex;

      @media (min-width: 780px) {
        margin-right: 20px;
      }

      & > div {
        width: 100%;
      }

      &-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
      }

      &__icon {
        align-self: center;
        margin-right: 12px;

        @media (max-width: 780px) {
          display: none;
          margin-right: 12px;
          place-self: baseline;
        }
      }

      p {
        font-size: 22px;
        font-weight: 700;
        line-height: 30px;
        margin: 0;

        @media (max-width: 780px) {
          font-size: 16px;
          line-height: 25px;
          margin-bottom: 6px;
        }
      }

      span {
        font-size: 16px;
        line-height: 22px;

        @media (max-width: 780px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    &__button {
      padding: 12px 20px;

      @media (max-width: 780px) {
        margin: 0;
        margin-top: 16px;
        padding: 8px 20px;
        width: 100%;
      }
    }
  }

  // Modifiers
  &-banner {
    &--srp-variant {
      margin-bottom: 20px;
      margin-top: 20px;

      @media (max-width: 780px) {
        margin-top: 32px;
      }
    }

    &--guided-search {
      border-bottom: 0.5px solid rgb(177 177 188 / 39%); // for border thinner than 1px
      padding: 12px 32px 12px 10px;

      @media (max-width: 780px) {
        padding: 20px 16px;
      }

      section {
        @media (min-width: 780px) {
          align-self: center;
        }
      }

      .smart-country-selector-banner {
        &-content {
          &__icon {
            display: initial;
            margin-right: 11px;
          }

          &-header {
            p {
              font-size: 16px;
              line-height: 25px;
            }
          }

          span {
            font-size: 14px;
          }
        }

        &__button {
          font-size: 14px;
          line-height: 16px;
          margin-right: 10px;
          padding: 9px 20px;

          @media (min-width: 780px) {
            width: 150px;
          }
        }
      }
    }
  }
}

.smart-country-selector-banner {
  &__button-section {
    margin-top: 16px;
    align-self: stretch;

    .smart-country-selector-banner__button {
      display: contents;
    }

    @media (min-width: 780px) {
      margin-top: 0;
      align-self: center;
      .smart-country-selector-banner__button {
        display: inline-block;
      }
    }
  }
}
